import type { ConfirmationsTranslations } from "../interfaces/confirmations";

export const confirmationsTranslations: ConfirmationsTranslations = {
  page_title: "Confirmaciones de Pagos",
  button_new_confirmation: "Nueva Confirmación",
  toast_error_load: "Error al cargar confirmaciones",
  toast_error_load_more: "Error al cargar más confirmaciones",
  toast_success_create: "Confirmación creada correctamente",
  toast_error_create: "Error al crear la confirmación",
  toast_success_cancel: "Confirmación cancelada correctamente",
  toast_error_cancel: "Error al cancelar la confirmación",
  toast_success_confirm: "Confirmación realizada correctamente",
  toast_warning_attachment: "Confirmación realizada, pero no se pudo subir la evidencia.",
  toast_error_confirm: "Error al confirmar la transacción",
  toast_success_notify: "Cliente notificado correctamente",
  toast_error_notify: "Error al notificar al cliente",
  toast_success_taker_reminder: "Recordatorio enviado correctamente",
  toast_error_taker_reminder: "Error al enviar el recordatorio",
  toast_no_image: "No hay imagen para abrir en nueva pestaña",
  loading: "Cargando…",
  show_more: "Mostrar más",
  alt_comprobante_pago: "Comprobante de pago",
  alt_comprobante_confirmacion: "Comprobante de confirmación",

  card_status_pending: "Pendiente",
  card_status_confirmed: "Confirmado",
  card_label_note: "Nota:",
  card_label_created_by: "Creado por:",
  card_label_updated_by: "Actualizado por:",
  card_label_created_at: "Fecha de creación:",
  card_label_updated_at: "Fecha de actualización:",
  card_button_notify_client: "Cliente notificado",
  card_button_taker_reminder: "Dar un toque",
  card_button_cancel: "Cancelar",
  card_button_confirm: "Confirmar",
  card_button_view_history: "Ver historial",
  card_verified: "Verificado",
  card_button_view: "Ver",
  card_button_open: "Abrir",
  card_loading: "Cargando…",
  card_error_load: "Error al cargar",
  card_alt_comprobante: "Comprobante",
  card_alt_comprobante_n: "Comprobante {{n}}",

  board_empty_title: "No hay confirmaciones de pago",
  board_empty_description:
    "Las confirmaciones que crees o que recibas aparecerán aquí. Usa el botón «Nueva confirmación» para registrar un comprobante de pago.",
  column_pending: "Pendientes",
  column_confirmed: "Confirmados",
  column_empty_pending: "No hay confirmaciones pendientes. Las nuevas confirmaciones aparecerán aquí.",
  column_refresh: "Actualizar",
  column_refresh_aria: "Actualizar confirmaciones",
  column_drag_to_confirm: "Arrastra para confirmar",

  modal_cancel_title: "Cancelar confirmación de pago",
  modal_cancel_description:
    "Por favor, indícanos el motivo por el cual deseas cancelar esta transacción. Esta acción no se puede deshacer una vez confirmada.",
  modal_cancel_label_reason: "Motivo de cancelación",
  modal_cancel_placeholder: "Escribe aquí el motivo de la cancelación...",
  modal_cancel_back: "Volver",
  modal_cancel_confirm: "Confirmar cancelación",
  modal_cancel_confirming: "Cancelando...",
  modal_cancel_required: "El motivo de cancelación es obligatorio.",
  modal_cancel_close_aria: "Cerrar",

  modal_new_title: "Nueva confirmación de pago",
  modal_new_submit: "Crear solicitud",
  modal_new_cancel: "Cancelar",

  modal_confirm_title: "Confirmar transacción",
  modal_confirm_description:
    "¿Estás seguro que deseas confirmar esta transacción? Esta acción será registrada en el historial.",
  modal_confirm_source_label: "Ingreso de banco",
  modal_confirm_source_placeholder: "Seleccione el ingreso de banco",
  modal_confirm_source_required: "El ingreso de banco es obligatorio.",
  modal_confirm_attach_evidence: "Anexar evidencia",
  modal_confirm_no_attachments: "No enviar adjuntos",
  modal_confirm_evidence_label: "Evidencia (imágenes)",
  modal_confirm_evidence_description: "PNG, JPG, WebP hasta 10 MB. Puedes elegir varios archivos.",
  modal_confirm_evidence_instruction: "Clic para seleccionar o arrastra archivos aquí",
  modal_confirm_back: "Volver",
  modal_confirm_confirm: "Confirmar",
  modal_confirm_evidence_required: "Debe adjuntar al menos un comprobante.",
  modal_confirm_close_aria: "Cerrar",

  modal_client_notified_title: "Cliente notificado",
  modal_client_notified_description:
    "El cliente fue notificado sobre esta confirmación de pago. La notificación queda registrada en el historial.",
  modal_client_notified_close: "Cerrar",
  modal_client_notified_confirm: "Confirmar",
  modal_client_notified_close_aria: "Cerrar",

  modal_history_title: "Detalle de confirmación de pago",
  modal_history_loading: "Cargando historial…",
  modal_history_error: "No se pudo cargar el historial.",
  modal_history_empty: "No hay registros en el historial.",
  modal_history_section_title: "Historial de cambios",
  modal_history_initial_status: "Estado inicial",
  modal_history_previous_status: "Estado anterior",
  modal_history_current_status: "Estado actual",
  modal_history_duration: "Duración",
  modal_history_close: "Cerrar",
  modal_history_close_aria: "Cerrar",
  status_pending: "Pendiente",
  status_confirmed: "Confirmado",
  status_cancelled: "Cancelado",
  status_archived: "Archivado",
  status_notified: "Notificado",
  change_type_created: "Creación",
  change_type_status: "Cambio de estado",
  change_type_data: "Actualización de datos",
  change_type_attachment: "Adjunto añadido",
  change_type_note: "Nota añadida",

  form_label_client: "Cliente",
  form_placeholder_client: "Ingrese nombre del cliente",
  form_checkbox_same_client: "Beneficiario es el mismo cliente",
  form_label_beneficiary: "Beneficiario",
  form_placeholder_beneficiary: "Beneficiario",
  form_label_amount: "Monto",
  form_label_currency: "Tipo de moneda",
  form_placeholder_currency: "Seleccionar moneda...",
  form_label_bank: "Banco",
  form_placeholder_bank: "Seleccionar método de pago...",
  form_placeholder_bank_currency_first: "Seleccione primero una moneda",
  form_label_date: "Fecha",
  form_label_note: "Nota",
  form_placeholder_note: "Agregar una nota a esta confirmación...",
  form_label_comprobante: "Comprobante (imagen)",
  form_comprobante_description: "PNG, JPG, WebP hasta 10 MB",
  form_comprobante_instruction: "Haz clic para subir o arrastra aquí",
  form_comprobante_instruction_drop: "Suelta el archivo aquí",
  form_comprobante_size_format: "Máximo {{max}} MB • Imágenes (JPG, PNG, WebP)",
  form_comprobante_preview_alt: "Vista previa del comprobante",
  form_comprobante_change: "Cambiar",
  form_comprobante_remove: "Quitar",

  validation_cliente_required: "El nombre del cliente es obligatorio.",
  validation_pagador_required: "El nombre del pagador es obligatorio.",
  validation_monto_invalid: "Ingrese un monto válido mayor a cero.",
  validation_banco_required: "El banco es obligatorio.",
  validation_moneda_required: "El tipo de moneda es obligatorio.",
  validation_fecha_required: "La fecha es obligatoria.",
  validation_comprobante_required: "El comprobante es obligatorio.",
};
